module.exports = __webpack_public_path__ + "static/img/honor_banner.f3b330a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/honor_banner.jpg
// module id = g3C6
// module chunks = 1